import React from 'react';
import Thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';
import { BrowserRouter } from 'react-router-dom';

import Reducers from '../reducers';

import App from './app';

import '../scss/index.scss';

const Logger = createLogger({
  predicate: () => process.env.NODE_ENV !== 'production',
  collapsed: true
});

const createStoreWithMiddleware = applyMiddleware(Thunk, Logger)(createStore);
export const store = createStoreWithMiddleware(Reducers);

const Root = () => (
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

ReactDOM.render(<Root />, document.getElementById('app'));
